import { SOURCE, Source } from "@/constants";

import DataDisplay, { DataDisplayComponent } from "./DataDisplay";

const SourceDisplay: DataDisplayComponent<Source> = (props) => {
  const SOURCE_MAP = {
    [SOURCE.PODCAST]: L.SOURCE_TYPE_PODCAST,
    [SOURCE.RADIO]: L.SOURCE_TYPE_RADIO,
    [SOURCE.TV]: L.SOURCE_TYPE_TV,
    [SOURCE.YOUTUBE]: L.SOURCE_TYPE_YOUTUBE,
    [SOURCE.WEB_TV]: L.SOURCE_TYPE_WEB_TV,
    [SOURCE.MANUAL]: L.SOURCE_TYPE_MANUAL,
    [SOURCE.FACEBOOK]: L.SOURCE_TYPE_FACEBOOK,
    [SOURCE.INSTAGRAM]: L.SOURCE_TYPE_INSTAGRAM,
    [SOURCE.TIKTOK]: L.SOURCE_TYPE_TIKTOK,
    [SOURCE.TWITTER]: L.SOURCE_TYPE_TWITTER,
    [SOURCE.LINKEDIN]: L.SOURCE_TYPE_LINKEDIN,
    [SOURCE.NEWS]: L.SOURCE_TYPE_NEWS,
  };

  const SOURCE_MAP_PLURAL = {
    [SOURCE.PODCAST]: L.SOURCE_TYPE_PLURAL_PODCAST,
    [SOURCE.MANUAL]: L.SOURCE_TYPE_PLURAL_MANUAL,
    [SOURCE.NEWS]: L.SOURCE_TYPE_PLURAL_NEWS,
  };
  return (
    <DataDisplay
      dictionary={SOURCE_MAP}
      pluralDictionary={SOURCE_MAP_PLURAL}
      {...props}
    />
  );
};

export default SourceDisplay;
